module.exports = __webpack_public_path__ + "img/jiulonghu.3b13db93.jpg";